
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/faq",
      function () {
        return require("private-next-pages/qmee/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/faq"])
      });
    }
  